import { Badge } from "reactstrap";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import { getStatusBadge } from "@src/utility/helpers/utils";
import upperCase from "lodash/upperCase";

export const getDecoColumns = () => {
    return [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "200px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    className=""
                    id={`name-${row._id}`}
                    max={30}/>
            )
        },
        {
            name    : "Companies",
            selector: (row) => row.noc,
            width   : "120px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.noc}
                    className="fw-bolder fs-3"
                    id={`noc-${row._id}`}
                    max={10}/>
            )
        },
        {
            name    : "% of Companies",
            selector: (row) => row.poc,
            width   : "150px",
            cell    : (row) => (
                <div className="d-flex align-items-center">
                    {parseFloat(row.poc).toFixed(2)}%
                </div>
            )
        },
        {
            name    : "Total MRR",
            selector: (row) => row.tmrr,
            width   : "150px",
            cell    : (row) => <span>${row.tmrr.toLocaleString()}</span>
        },
        {
            name    : "% of MRR",
            selector: (row) => row.pmrr,
            width   : "150px",
            cell    : (row) => (
                <div className="d-flex align-items-center">
                    {parseFloat(row.pmrr).toFixed(2)}%
                </div>
            )
        },
        {
            name    : "Role",
            selector: (row) => row.role,
            width   : "120px",
            cell    : (row) => {
                const statusBadge = getStatusBadge(row.role);
                return (
                    <Badge color={statusBadge?.color}>
                        {upperCase(statusBadge?.title)}
                    </Badge>
                );
            }
        },
        {
            name    : "On-time Tasks",
            selector: (row) => row.ottc,
            width   : "120px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.ottc}
                    className="fw-bolder fs-3 text-primary"
                    id={`ottc-${row._id}`}
                    max={10}/>
            )
        },
        {
            name    : "Overdue Tasks",
            selector: (row) => row.odtc,
            width   : "120px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.odtc}
                    className="fw-bolder fs-3 text-warning"
                    id={`odtc-${row._id}`}
                    max={10}/>
            )
        },
        {
            name    : "Completed Tasks",
            selector: (row) => row.ctc,
            width   : "140px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.ctc}
                    className="fw-bolder fs-3 text-success"
                    id={`ctc-${row._id}`}
                    max={10}/>
            )
        },
        {
            name    : "Notes",
            selector: (row) => row.nc,
            width   : "100px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.nc}
                    className="fw-bolder fs-3 text-info"
                    id={`nc-${row._id}`}
                    max={10}/>
            )
        }
    ];
};
